import http from "../http-common";

class AuthService {

  login(data) {
    return http.post("/userAuth/login", data);
  }
  logout(data) {
    return http.post("/userAuth/logout", data);
  }
  setPassword(data) {
    return http.post("/userAuth/setPassword", data);
  }
  forgotPassword(data) {
    return http.post("/userAuth/password", data);
  }

  /**
   * Set User into local storage to avoid queris again n again.
   * @param profile
   */
  setCurrentUser(profile) {
    const user = {
      firstName: profile.firstName,
      lastName: profile.lastName
    };
    localStorage.setItem('currentUser', JSON.stringify(user));
  }



  /**
   * Set User into local storage to avoid queris again n again.
   * @param profile
   */
  getCurrentUser() {
    const profileData = localStorage.getItem('currentUser');
    if ( profileData !== null ) {
      return JSON.parse(profileData);
    }
    return null;
  }

  isAuthenticated() {
    return new Promise((resolve, reject)=>{
        const loginData = JSON.parse(localStorage.getItem('loginData'));
        if (!loginData)
            resolve({isAuthenticated: false, user: null, roleId: null});
        else
            resolve({isAuthenticated: true, user: loginData, roleId: loginData.user.roleId});
    });
}}

export default new AuthService();
